const domains = {
    "httpapi": "https://apitext.yk3music.com",
    "socketapi": "https://sockettext.yk3music.com",
    "queueapi": "https://queuetext.yk3music.com",
    "presenceapi": "https://presencetext.yk3music.com",
    "exportapi": "https://exporttext.yk3music.com",
}


export default domains;